import {Pagination} from '../../../utils/pagination'
import CostAnalysisReportHeader from '../sections/header/CostAnalysisReportHeader'
import CostAnalysisReportTable from '../sections/tables/CostAnalysisReportTable'
import {CostAnalysisReportContext} from '../context'
import useGetCostAnalysisReportList from '../hooks/useGetCostAnalysisReportList'

const CostAnalysisReport = () => {
  const {
    costAnalysisReportList,
    pagination,
    isLoading,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
  } = useGetCostAnalysisReportList()

  const contextValues = {
    costAnalysisReportList,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
  }

  return (
    <CostAnalysisReportContext.Provider value={contextValues}>
      <CostAnalysisReportHeader />
      <CostAnalysisReportTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </CostAnalysisReportContext.Provider>
  )
}

export default CostAnalysisReport
